import './jquery-global.js';
import './scene.js';
import 'lightbox2';
import inlineSVG from 'Vendor/inlineSvg';

import whenVisible from 'Utils/whenVisible.js';
import eachElement from 'Utils/eachElement.js';
import Tabs from './tabs.js';
import Dropdown from './dropdown.js';
import parallax from './parallax.js';
import topicsCarousel from './carousels/topics.js';

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

$(function() {
	/* Load SVGs inline, so we can colour them */
	inlineSVG.init({
		svgSelector: 'img.svg',
		initClass: 'js-inlinesvg',
	});

	/* Listen to scrolling */
	$(window).on("load scroll resize", function() {
		/* Parallax scrolling effect */
		if ($('.parallax:visible').length) {
			parallax();
		}

		/* Set class when scrolled */
		document.documentElement.classList.toggle('has-scrolled', $(window).scrollTop() > 0);
	});

	/* Toggle menu */
	document.getElementById('nav-toggle').addEventListener('click', () => {
		document.documentElement.classList.toggle('has-menu-visible');
		document.documentElement.classList.contains('has-menu-visible') ? disableBodyScroll() : enableBodyScroll();
	});

	/* Set up tabs */
	eachElement('.tabs', instance => {
		new Tabs(instance);
	});

	/* Set up dropdowns */
	eachElement('.dropdown', instance => {
		new Dropdown(instance);
	});

	/* Set up carousels */
	if (document.querySelector('.swiper.topics')) {
		topicsCarousel();
	}

	if (window.matchMedia('(min-width: 768px)').matches) {
		/* Apply class when element is visible */
		whenVisible();
	}
});
